<template>
  <VIcon
    :icon="icon"
    :size="size"
    :color="color"
    :class="{ 'icon--stretch': stretch }"
    class="icon"
  />
</template>

<script setup lang="ts">
import { VIcon } from 'vuetify/components/VIcon';

withDefaults(
  defineProps<{
    icon: string;
    size?: string;
    color?: string;
    stretch?: boolean;
  }>(),
  {
    size: '24',
    color: 'currentColor',
    stretch: false,
  },
);
</script>

<style lang="scss" scoped>
.icon--stretch :deep(svg) {
  width: 100%;
  height: 100%;
}
</style>
